/**
 * Intro / Loading Sequence
 *
 * Orchestrates the three-step text reveal on first homepage visit.
 * Skips immediately on repeat visits (sessionStorage) and on
 * prefers-reduced-motion.
 *
 * Sequence:
 *   0ms     — page ready, scroll locked
 *   200ms   — step-1: "OUR CITY."   clips up (900ms CSS transition)
 *   900ms   — step-2: "YOUR STORY." clips down (900ms CSS transition)
 *   1600ms  — step-3: tagline fades in (500ms CSS transition)
 *   2400ms  — step-exit: overlay slides up off screen (900ms CSS transition)
 *   3300ms  — overlay hidden, scroll restored, intro-done on body
 */
( function () {
	'use strict';
 
	var SESSION_KEY = 'spencerBlock_introSeen';
 
	function skipIntro( overlay ) {
		overlay.classList.add( 'is-hidden' );
		document.body.classList.remove( 'intro-active' );
		document.body.classList.add( 'intro-done' );
	}
 
	function runIntro( overlay ) {
		document.body.classList.add( 'intro-active' );
 
		// Step 1 — "OUR CITY." clips up from bottom
		setTimeout( function () {
			overlay.classList.add( 'step-1' );
		}, 100 );
 
		// Step 2 — "YOUR STORY." clips down from top
		setTimeout( function () {
			overlay.classList.add( 'step-2' );
		}, 600 );
 
		// Step 3 — tagline fades in
		setTimeout( function () {
			overlay.classList.add( 'step-3' );
		}, 1200 );
 
		// Exit — overlay slides up off screen
		setTimeout( function () {
			overlay.classList.add( 'step-exit' );
		}, 2200 );
 
		// Done — remove overlay from layout, restore scroll
		setTimeout( function () {
			overlay.classList.add( 'is-hidden' );
			document.body.classList.remove( 'intro-active' );
			document.body.classList.add( 'intro-done' );
		}, 3000 );
 
		// Mark session so repeat visits skip the animation
		try {
			sessionStorage.setItem( SESSION_KEY, '1' );
		} catch ( e ) { /* sessionStorage unavailable — silently skip */ }
	}
 
	function init() {
		var overlay = document.getElementById( 'intro' );
		if ( ! overlay ) return;
 
		// Skip: mobile / touch widths.
		//
		// The overlay is already hidden by CSS at this width (see the mobile
		// block in _preloader.scss) — this bail just avoids scheduling five
		// pointless timers and locking scroll on the devices we are optimising
		// for. 1024px matches the `isMobile` cutoff already used in theme.js.
		//
		// skipIntro() is still called so `intro-done` lands on <body> in case
		// anything else keys off it. The mobile hero no longer depends on that
		// class to be visible, but other scripts may.
		if ( window.matchMedia( '(max-width: 1024px)' ).matches ) {
			skipIntro( overlay );
			return;
		}

		// Skip: prefers-reduced-motion
		if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
			skipIntro( overlay );
			return;
		}
 
		// Skip: already seen this session
		try {
			if ( sessionStorage.getItem( SESSION_KEY ) ) {
				//skipIntro( overlay );
				//return;
			}
		} catch ( e ) { /* sessionStorage unavailable — play the intro */ }
 
		runIntro( overlay );
	}
 
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
 
} )();

